export const LOCAL_STORAGE_PERSIST_KEY = 'movie_pf_ap';
